module.exports = __webpack_public_path__ + "img/logo.e5a3aaf7.png";